import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useTrackOriginClick} from '@aboutyou/tracking';

const useOriginClickTrackingFunction = (originClick: originClick) => {
  const trackingOrigin = useTrackOriginClick();
  return trackingOrigin(originClick);
};

export const useTrackFlyoutOriginClick = () =>
  useOriginClickTrackingFunction('flyout');

export const useTrackBrandItemOriginClick = () =>
  useOriginClickTrackingFunction('global_top_brands_reco');

export const useTrackNavigationBarOriginClick = () =>
  useOriginClickTrackingFunction('navigation_bar');

export const useTrackHeaderOriginClick = () =>
  useOriginClickTrackingFunction('header');

export const useTrackMetaBarOriginClick = () =>
  useOriginClickTrackingFunction('metabar');
